import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import ExecCard from './ExecCard'; 
import axios from '../axiosConfig';
import '../assets/styles/ExecByPractice.css';

const ExecByPractice = () => {
  const [practices, setPractices] = useState([]);
  const [selectedPractice, setSelectedPractice] = useState(null);
  const [selectedExecPartners, setSelectedExecPartners] = useState([]); 
  const [isLoading, setIsLoading] = useState(false);

  // Fetch practices when the component loads
  useEffect(() => {
    const fetchPractices = async () => {
      try {
        const response = await axios.get('/api/practices');
        const data = response.data.data;
        setPractices(response.data.data);
        if (data.length > 0) setSelectedPractice(data[0].id); 
      } catch (error) {
        console.error('Erreur lors de la récupération des secteurs:', error);
      }
    };
    fetchPractices();
  }, []);

  
  useEffect(() => {
    const fetchExecPartners = async () => {
      if (!selectedPractice) return;

      setIsLoading(true); 
      try {
        const response = await axios.get('/api/exec-partners/by-practices', {
          params: { id: selectedPractice },
        });

        const data = response.data.data;
        setSelectedExecPartners(data);
      } catch (error) {
        console.error('Error fetching exec_partners:', error);
      } finally {
        setIsLoading(false); 
      }
    };
    fetchExecPartners();
  }, [selectedPractice]);

  

  return (
    <div>
      <Container>
        {/* Tab menu */}
        <Nav variant="tabs" className="justify-content-center nav-tabs" defaultActiveKey="All">
          {practices.map((practice) => (
            <Nav.Item key={practice.id}>
              <Nav.Link eventKey={practice.name} onClick={() => setSelectedPractice(practice.id)}>
                {practice.name}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        
        <Row className="mt-4">
          {/* Loader or Exec Partners list */}
          {isLoading ? (
            <p className="loader">Loading ...</p>
          ) : selectedExecPartners.length > 0 ? (
            selectedExecPartners.map((partner) => (
              <Col md={6} key={partner.id}>
                <ExecCard
                  key={partner.id}
                  first_name={partner.user.first_name}
                  last_name={partner.user.last_name}
                  email={partner.user.email}
                  bio={partner.bio}
                  experience={partner.experience}
                  education={partner.education}
                  rating={partner.rating}
                  available={partner.available}
                  sectors={partner.user.sectors.map(s => s.name).join(', ')} 
                  practices={partner.user.practices.map(p => p.name).join(', ')}
                />
              </Col>
            ))
          ) : (
            <p>No exec partner found for the selected area.</p>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default ExecByPractice;